/**
 * 代理商分销
 */
export const CHANGE_IS_FROM_WITHDRAW = 'CHANGE_IS_FROM_WITHDRAW';
export const CHANGE_IS_TO_HELP = 'CHANGE_IS_TO_HELP';
